import React from 'react';
import { about, sisterProjects } from '../data/siteContent';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="border-t border-ink/12 section-y">
      <div className="shell">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-gutter">
          <div className="lg:col-span-7">
            <p className="kicker-action">{about.eyebrow}</p>
            <h2 className="display-lg mt-5 text-[2.25rem] sm:text-[2.85rem]">{about.title}</h2>
            <p className="prose-reading mt-6 max-w-reading">{about.body}</p>
          </div>

          <dl className="lg:col-span-5">
            <p className="kicker mb-4">Credits and sources</p>
            {about.credits.map((credit) => (
              <div key={credit.label} className="border-t border-ink/12 py-3.5">
                <dt className="kicker">{credit.label}</dt>
                <dd className="mt-1 font-heading text-[0.9375rem] text-text">{credit.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-gutter border-t-2 border-ink pt-10">
          <p className="kicker">More from Saar Labs</p>
          <ul className="mt-8 grid list-none gap-px bg-ink/12 md:grid-cols-2">
            {sisterProjects.map((project) => (
              <li key={project.name} className="flex flex-col bg-background p-7 sm:p-8">
                <h3 className="display-sm text-xl">{project.name}</h3>
                <p className="kicker mt-2">{project.tagline}</p>
                <p className="prose-note mt-4 flex-1">{project.description}</p>
                <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
                  {project.links.map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-action font-body text-[0.8125rem] font-semibold uppercase tracking-small-caps"
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
